import axios from "axios";

const SCHOOL_AUTH_STORAGE_KEY = "school-portal-user";

const getStoredSchoolUser = () => {
  try {
    const storedSchoolUser = localStorage.getItem(SCHOOL_AUTH_STORAGE_KEY);
    return storedSchoolUser ? JSON.parse(storedSchoolUser) : null;
  } catch {
    localStorage.removeItem(SCHOOL_AUTH_STORAGE_KEY);
    return null;
  }
};

const schoolPortalHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

schoolPortalHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredSchoolUser()?.token;

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

schoolPortalHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(SCHOOL_AUTH_STORAGE_KEY);
      window.location.href = "/school-portal/login";
    }

    return Promise.reject(error);
  },
);

export default schoolPortalHttpCommon;
